// String methods inspired by underscore.string
// https://github.com/esamattis/underscore.string

import {cleanDiacritics, makeString, trim} from './helpers'

/**
 * Capitalize string
 * @param str
 * @param lowercase
 * @returns {string}
 */
export const capitalize = (str, lowercase) => {
    str = makeString(str)
    const remainingChars = !lowercase
        ? str.slice(1)
        : str.slice(1).toLowerCase()

    return str.charAt(0).toUpperCase() + remainingChars
}

/**
 * transform string to snake case
 * @param str
 * @returns {string}
 */
export const underscored = (str) => {
    return trim(str).replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase()
}

/**
 * Transform string to human readable (strips, _, -. etc.)
 * @param str
 * @returns {string}
 */
export const humanize = (str) => {
    return capitalize(trim(underscored(str).replace(/_id$/, '').replace(/_/g, ' ')))
}

/**
 * Transform string to kebab case
 * @param str
 * @returns {string}
 */
export const dasherize = (str) => {
    return trim(str).replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase()
}

/**
 * Transform string to slug
 * @param str
 * @returns {string}
 */
export const slugify = (str) => {
    return trim(dasherize(cleanDiacritics(str).replace(/[^\w\s-]/g, '-').toLowerCase()), '-')
}

/**
 * Remove capitalization from string
 * @param str
 * @returns {string}
 */
export const decapitalize = (str) => {
    str = makeString(str)
    return str.charAt(0).toLowerCase() + str.slice(1)
}

/**
 * Convert string to camelcase
 * @param str
 * @param decapitalize
 * @returns {string|*}
 */
export const camelize = (str, decapitalize) => {
    str = trim(str).replace(/[-_\s]+(.)?/g, function (match, c) {
        return c ? c.toUpperCase() : ''
    })

    return decapitalize
        ? decapitalize(str)
        : str
}

/**
 * Convert string to title
 * @param str
 * @returns {string}
 */
export const titleize = (str) => {
    return makeString(str).toLowerCase().replace(/(?:^|\s|-)\S/g, function (c) {
        return c.toUpperCase()
    })
}

/**
 * Converts string to human format and then titleizes it
 * @param string
 * @returns {string}
 */
export const formatAsTitle = (string) => titleize(humanize(string))

/**
 * export methods
 */
export default {
    camelize,
    capitalize,
    dasherize,
    decapitalize,
    formatAsTitle,
    humanize,
    slugify,
    titleize,
    underscored
}
